import { render, staticRenderFns } from "./ebook-dropdown.vue?vue&type=template&id=23fdd2b4&scoped=true&"
import script from "./ebook-dropdown.vue?vue&type=script&lang=js&"
export * from "./ebook-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./ebook-dropdown.vue?vue&type=style&index=0&id=23fdd2b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fdd2b4",
  null
  
)

export default component.exports